import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import FilterContainer from '../forms/FilterContainer';
import {preloadedFilterQueryParamsState} from '../../constants/preloaded-states';
import FilterPanel from '../common/FilterPanel';
import {TYPE_QUALITY_ISSUES} from '../../constants/issue-types';

class ProjectListFilterPanel extends PureComponent {
  getPreloadedQueryParamsState() {
    return preloadedFilterQueryParamsState[this.props.viewType][TYPE_QUALITY_ISSUES];
  }

  resetFilters = () => {
    const preloadedQueryParamsState = this.getPreloadedQueryParamsState();
    this.props.setQueryParamsAction(preloadedQueryParamsState);
  };

  render() {
    const {isFilterPanelOpen, isFiltered, closeFilterPanel} = this.props;
    return (
      <FilterPanel
        closeFilterPanel={closeFilterPanel}
        isFilterPanelOpen={isFilterPanelOpen}
        isFiltered={isFiltered}
        resetFilters={this.resetFilters}
      >
        <FilterContainer visible useFilterPanel outsideClickIgnoreClass="" container={this.props.container} />
      </FilterPanel>
    );
  }
}

ProjectListFilterPanel.displayName = 'ProjectListFilterPanel';

ProjectListFilterPanel.propTypes = {
  viewType: PropTypes.string.isRequired,
  isFilterPanelOpen: PropTypes.bool,
  isFiltered: PropTypes.bool,
  closeFilterPanel: PropTypes.func.isRequired,
  setQueryParamsAction: PropTypes.func.isRequired,
  container: PropTypes.object
};

export default ProjectListFilterPanel;
